"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const IntermediateCheckmark = createSVGIcon(
  <path
    d="M4.571 8h6.857"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "IntermediateCheckmark",
  {
    viewBox: "0 0 16 16",
    titleAccess: "IntermediateCheckmark",
    strokeWidth: 1.5,
    className: legacyIconCls(),
  }
);
